export default "https://cdn-static.gokick.com/assets/90becb6b185a352a9c07d0641a2a2a86ee77cb9a/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";